import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { Submission } from 'utils';

type ReturnType = Promise<AxiosResponse<Submission>>;

const startNewFormSubmissionWithoutGroup = (id: string): ReturnType => {
    return Request.post(`/data/forms/${id}/submissions`, {
        member: '-',
    });
};
export default startNewFormSubmissionWithoutGroup;
